module.exports = __webpack_public_path__ + "img/media_banner_btn.7c6c9af6.png";